var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('l-map',{staticStyle:{"height":"100%","width":"100%","border-radius":"0.5rem"},attrs:{"zoom":_vm.zoom,"center":_vm.center}},[_c('l-tile-layer',{attrs:{"url":_vm.url}}),_c('l-marker',{attrs:{"lat-lng":_vm.markerLatLng,"icon":_vm.icon}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }